import { render, staticRenderFns } from "./TabPaymentsTable.vue?vue&type=template&id=1ce3a972&scoped=true&lang=pug"
import script from "./TabPaymentsTable.vue?vue&type=script&lang=js"
export * from "./TabPaymentsTable.vue?vue&type=script&lang=js"
import style0 from "./TabPaymentsTable.vue?vue&type=style&index=0&id=1ce3a972&prod&lang=scss&scoped=true"
import style1 from "./TabPaymentsTable.vue?vue&type=style&index=1&id=1ce3a972&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce3a972",
  null
  
)

export default component.exports